import styled from 'styled-components'

export const Tips = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${(p) => p.theme.text._3};
`

export const FileDisplay = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  &&& {
    .ant-upload-list {
      display: none;
    }
  }
`

export const DisplayMsgLabel = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${(p) => p.theme.text._3};
`

export const UploadButton = styled.div<{
  $backgroundColor?: string
}>`
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 16px 12px;
  background: ${(props) =>
    props.$backgroundColor
      ? props.$backgroundColor
      : props.theme.background._3};
  border: 1px dashed ${(props) => props.theme.border.greyNormal};
  cursor: pointer;
`
